// React
import React, { useEffect, useState } from "react";

// Utility functions - hooks - API endpoints - and ext. plugins
import { getPositions } from "../../../../../api/endpoints/position";
import { Typography } from "../../../../../components/Typography";
import { PositionGreyList, SelectedPositionsWrapper } from "./UsersCard.styled";
import { Flex } from "../../../../style";
import { useTranslation } from "react-i18next";

const SelectedPositions = ({ user }) => {
  const { t } = useTranslation();
  const [positions, setPositions] = useState();

  useEffect(() => {
    const fetchPositions = async () => {
      try {
        const response = await getPositions();
        if (response.success) {
          setPositions(response.data);
        }
      } catch (err) {
        console.log(err);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    fetchPositions();
  }, [user]);

  // Filter positions based on user.positionsAccess
  const filteredPositions = positions?.filter((position) =>
    user.positionsAccess.includes(position.id.toString())
  );

  return (
    <SelectedPositionsWrapper>
      <Flex flexWrap>
        {user.positionsAccess.includes("all") && (
          <PositionGreyList markedColors>
            <Typography tag="p" nomargin ml="0" large>
              {t("common.position.all_positions", "All positions")}
            </Typography>
          </PositionGreyList>
        )}
        {user.positionsAccess.length === 0 && (
          <PositionGreyList warningColors>
            <Typography tag="p" nomargin ml="0" large>
              {t("common.position.no_positions", "No positions")}
            </Typography>
          </PositionGreyList>
        )}
        {filteredPositions?.map((filteredPosition) => (
          <React.Fragment key={filteredPosition.id}>
            <PositionGreyList>
              <Typography tag="p" nomargin ml="0" large>
                {filteredPosition.title}
              </Typography>
            </PositionGreyList>
          </React.Fragment>
        ))}
      </Flex>
    </SelectedPositionsWrapper>
  );
};

export default SelectedPositions;
